import { Text, VFlow } from 'bold-ui'
import React from 'react'

import { NewsHeadingSection } from './NewsHeadingSection'

export function NewsInternalEstabilizacaoV42() {
  return (
    <VFlow>
      <NewsHeadingSection title='Versão 4.2.4' subtitle=' | 02/06/2021'>
        <VFlow vSpacing={0.5}>
          <Text component='li'>Correção de erro ao tentar realizar login no sistema.</Text>
        </VFlow>
      </NewsHeadingSection>
    </VFlow>
  )
}
